module.exports = __webpack_public_path__ + "static/media/commercial-insurance_640_color.9ea54937.png";